export function shouldNotifyCurrentAnalysisInProgress(
  {status, analysisAssignType, preanalysisAssignType}: {
    status: string;
    analysisAssignType: "DOCTOR" | "CHAIN" | "GLOBAL_TECHNICIAN_POOL" | undefined;
    preanalysisAssignType: "DOCTOR" | "CHAIN" | "GLOBAL_TECHNICIAN_POOL" | undefined;
  }) {
  if (status === "READY_FOR_ANALYSIS") {
    return analysisAssignType !== "DOCTOR";
  }

  if (status === "PRE_ANALYSIS") {
    return preanalysisAssignType !== "DOCTOR";
  }

  return false;
}
